import { motion } from "framer-motion";

/**
 * FlowBackdrop — a decorative, animated "capital flow" vector layer.
 * Curved routes with packets travelling along them, standing in for money
 * moving from overseas accounts into Indian investment rails. Purely
 * decorative: sits behind content at low opacity, never intercepts pointers.
 *
 * variant: "light" (on cloud-white sections) | "dark" (on ink-navy sections)
 */

const ROUTES = [
  { d: "M-40 120 C 220 60, 420 200, 700 130 S 1120 40, 1480 110", dur: 9, delay: 0 },
  { d: "M-40 260 C 260 200, 480 330, 760 250 S 1160 170, 1480 240", dur: 11, delay: 1.4 },
  { d: "M-40 400 C 200 350, 460 460, 720 390 S 1140 300, 1480 370", dur: 13, delay: 2.6 },
];

export default function FlowBackdrop({ variant = "light", className = "" }) {
  const stroke = variant === "dark" ? "rgba(255,255,255,0.35)" : "#4F63F0";
  const packet = variant === "dark" ? "#8B9AF7" : "#4F63F0";
  const node = "#1CB0A4";
  const baseOpacity = variant === "dark" ? 0.5 : 0.35;

  return (
    <div
      aria-hidden
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
      data-testid="flow-backdrop"
    >
      <svg
        viewBox="0 0 1440 500"
        preserveAspectRatio="xMidYMid slice"
        className="w-full h-full"
        style={{ opacity: baseOpacity }}
      >
        {ROUTES.map((r, i) => (
          <g key={r.d}>
            {/* Route */}
            <motion.path
              d={r.d}
              fill="none"
              stroke={stroke}
              strokeWidth="1.25"
              strokeOpacity={0.28}
              strokeDasharray="6 10"
              initial={{ pathLength: 0 }}
              whileInView={{ pathLength: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.6, delay: i * 0.2, ease: "easeOut" }}
            />

            {/* Travelling capital packet */}
            <circle r={i === 1 ? 4 : 3.25} fill={packet}>
              <animateMotion dur={`${r.dur}s`} repeatCount="indefinite" begin={`${r.delay}s`} path={r.d} />
              <animate
                attributeName="opacity"
                values="0;1;1;0"
                dur={`${r.dur}s`}
                repeatCount="indefinite"
                begin={`${r.delay}s`}
              />
            </circle>

            {/* Trailing echo packet */}
            <circle r="2" fill={node} opacity="0.75">
              <animateMotion
                dur={`${r.dur * 1.35}s`}
                repeatCount="indefinite"
                begin={`${r.delay + 1.8}s`}
                path={r.d}
              />
            </circle>
          </g>
        ))}
      </svg>
    </div>
  );
}
